<div class="system-notification__content">
  <span [innerHTML]="message">message</span>
</div>
<a href="#" (click)="closeNotification($event)" class="system-notification__close">
  <svg-icon src="assets/images/svg/icons/main-nav/close.svg"></svg-icon>
</a>
